import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { EnvironmentBannerComponent } from '@shared/components';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, EnvironmentBannerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'rocket-capture';
}
